import { render, staticRenderFns } from "./StepMatchingRoutinesV2.vue?vue&type=template&id=5264b910&scoped=true"
import script from "./StepMatchingRoutinesV2.vue?vue&type=script&lang=js"
export * from "./StepMatchingRoutinesV2.vue?vue&type=script&lang=js"
import style0 from "./StepMatchingRoutinesV2.vue?vue&type=style&index=0&id=5264b910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5264b910",
  null
  
)

export default component.exports